function clampNumber(value, min, max) {
  const number = Number(value);

  if (!Number.isFinite(number)) {
    return min;
  }

  return Math.min(Math.max(number, min), max);
}

export default function RangeMetric({ metric }) {
  if (!metric || metric.type !== 'range') {
    return null;
  }

  const label = typeof metric.label === 'string' ? metric.label.trim() : '';
  const text = typeof metric.text === 'string' ? metric.text.trim() : '';

  const min = Number.isFinite(Number(metric.min)) ? Number(metric.min) : 0;
  const max = Number.isFinite(Number(metric.max)) ? Number(metric.max) : 5;
  const value = clampNumber(metric.value, min, max);

  const total = Math.max(0, max - min);
  const filled = Math.max(0, value - min);

  if (!label || total <= 0) {
    return null;
  }

  return (
    <div className="savora-range-metric">
      <div className="savora-range-metric__header">
        <span className="savora-range-metric__label">{label}</span>
        {text ? <span className="savora-range-metric__text">{text}</span> : null}
      </div>

      <div
        className="savora-range-metric__bar"
        role="meter"
        aria-label={label}
        aria-valuemin={min}
        aria-valuemax={max}
        aria-valuenow={value}
      >
        {Array.from({ length: total }).map((_, index) => {
          const isFilled = index < filled;

          return (
            <span
              key={index}
              className={
                isFilled ? 'savora-range-metric__segment is-filled' : 'savora-range-metric__segment'
              }
            />
          );
        })}
      </div>
    </div>
  );
}
